import GetMenuItemResponse from '../CRM/Responses/MenuItemResponse';

import Model from './Model';
import Page from './Page';

export default class MenuItem extends Model {
    readonly id: number;
    readonly order: number;
    readonly name: string;
    readonly url: string = '';
    readonly type: string = 'url';
    readonly page_id: number = null;
    readonly page_parameters: Record<string, string | number> | null = null;
    readonly page: Page | null = null;
    readonly class: string = '';
    readonly group_name: string | null = null;
    readonly rel_nofollow: boolean = false;
    readonly menu_id: number;
    readonly parent_id: number = null;
    readonly icon: string = '';
    readonly open_in_new_tab: boolean = false;
    readonly expanded_by_default: boolean = false;
    readonly visibility: string = 'all';

    constructor(menuItem: Partial<GetMenuItemResponse>) {
        super();
        this.assignDataToProps(menuItem, [
            'id',
            'order',
            'name',
            'url',
            'type',
            'page_id',
            'page_parameters',
            'class',
            'group_name',
            'rel_nofollow',
            'menu_id',
            'parent_id',
            'icon',
            'open_in_new_tab',
            'expanded_by_default',
            'visibility',
        ]);

        this.page = menuItem.page ? new Page(menuItem.page) : null;
    }
}
